/**
 * Image Content block – subtitle animation + real parallax on media (image moves slower than scroll).
 */
import './style.scss';

function initImageContentInView() {
	const blocks = document.querySelectorAll( '.image-content' );
	if ( ! blocks.length ) return;

	const observer = new IntersectionObserver(
		( entries ) => {
			entries.forEach( ( entry ) => {
				if ( entry.isIntersecting ) {
					entry.target.classList.add( 'is-in-view' );
				}
			} );
		},
		{ rootMargin: '0px 0px -80px 0px', threshold: 0.1 }
	);

	blocks.forEach( ( block ) => observer.observe( block ) );
}

// Parallax: image moves at a fraction of scroll speed; disabled on mobile (below 768px)
const PARALLAX_SPEED = 0.4;
const HEADER_OFFSET = 68;
const PARALLAX_MIN_WIDTH = 768;
let parallaxTicking = false;

function updateParallax() {
	const isMobile = window.innerWidth < PARALLAX_MIN_WIDTH;

	document
		.querySelectorAll( '.js-parallax-wrapper' )
		.forEach( ( wrapper ) => {
			const media = wrapper.querySelector( '.js-parallax-media' );
			if ( ! media ) return;

			if ( isMobile ) {
				media.style.transform = '';
				return;
			}

			const rect = wrapper.getBoundingClientRect();
			const viewportHeight = window.innerHeight;

			if (
				rect.bottom < HEADER_OFFSET - 50 ||
				rect.top > viewportHeight + 50
			) {
				media.style.transform = '';
				return;
			}

			const topRelativeToVisible = rect.top - HEADER_OFFSET;
			const translateY = -topRelativeToVisible * ( 1 - PARALLAX_SPEED );
			media.style.transform = `translate3d(0, ${ translateY }px, 0)`;
		} );
	parallaxTicking = false;
}

function requestParallaxTick() {
	if ( ! parallaxTicking ) {
		parallaxTicking = true;
		requestAnimationFrame( updateParallax );
	}
}

function init() {
	initImageContentInView();
	window.addEventListener( 'scroll', requestParallaxTick, { passive: true } );
	window.addEventListener( 'resize', requestParallaxTick );
	window.addEventListener( 'load', updateParallax );
	updateParallax();
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', init );
} else {
	init();
}
